import { render, staticRenderFns } from "./addAuxiliaryMaterial.vue?vue&type=template&id=e23a92b4&scoped=true"
import script from "./addAuxiliaryMaterial.vue?vue&type=script&lang=js"
export * from "./addAuxiliaryMaterial.vue?vue&type=script&lang=js"
import style0 from "./addAuxiliaryMaterial.vue?vue&type=style&index=0&id=e23a92b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23a92b4",
  null
  
)

export default component.exports